import { styled, Select, InputBase, Autocomplete } from "@mui/material";

export const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    position: "relative",
    border: "solid 1px #979797",
    backgroundColor: "#fff",
    fontSize: 16,
    width: "100%",
    padding: "10px 12px",
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ])
  },
}));

export const BootstrapSelect = styled(Select)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    position: "relative",
    border: "solid 1px #979797",
    backgroundColor: "#fff",
    fontSize: 16,
    width: "100%",
    padding: "10px 12px",
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ])
  },
}));

export const BootstrapAutocomplete = styled(Autocomplete)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiFormControl-root": {
    "& .MuiOutlinedInput-root": {
      padding: "0px",
      border: "none",
      "& .MuiAutocomplete-input": {
        position: "relative",
        border: "solid 1px #979797",
        borderRadius: "4px",
        backgroundColor: "#fff",
        fontSize: 16,
        width: "100%",
        padding: "10px 12px",
        transition: theme.transitions.create([
          "border-color",
          "background-color",
          "box-shadow",
        ])
      },
    },
  },
}));
